import { Pipe, PipeTransform } from '@angular/core'
import { DateFormat } from '../../../config/global-const'
import { format } from 'date-fns'
@Pipe({
    name: 'DateCustomPipe',
    pure: true,
})
export class DateCustomPipe implements PipeTransform {
    transform(value: string | Date, args: string = DateFormat.DEFAULT_FORMAT): any {
        if (!value) {
            return ''
        }
        return format(new Date(value), args)
    }
}
